// NORM Storage Service — Local persistence
// Replaces Claude.ai's window.storage with localStorage + JSON

const PREFIX = "norm_";

export const storage = {
  async get(key) {
    try {
      const val = localStorage.getItem(PREFIX + key);
      return val ? { key, value: val } : null;
    } catch(e) { return null; }
  },

  async set(key, value) {
    try {
      localStorage.setItem(PREFIX + key, value);
      return { key, value };
    } catch(e) { return null; }
  },

  async delete(key) {
    try {
      localStorage.removeItem(PREFIX + key);
      return { key, deleted: true };
    } catch(e) { return null; }
  },

  async list(prefix = "") {
    try {
      const keys = [];
      for (let i = 0; i < localStorage.length; i++) {
        const k = localStorage.key(i);
        if (k.startsWith(PREFIX + prefix)) {
          keys.push(k.replace(PREFIX, ""));
        }
      }
      return { keys };
    } catch(e) { return { keys: [] }; }
  },
};

// Drop-in replacement: assign to window for backward compatibility
if (typeof window !== "undefined") {
  window.storage = storage;
}
